module.exports = __webpack_public_path__ + "img/26.97a16851.webp";